import { QuestionCircleOutlined } from '@ant-design/icons'
import Api from '@api/home'
import { isSiDaProperty } from '@merchant-backend/util'
import { isHotelMerchant, isTeam } from '@util'
import cls from 'classnames'
import { Button, Steps, Tooltip } from 'hljd'
import React, { Component } from 'react'
import auth, { SHOP_ASSISTANT } from '../auth'
import getPath from './path'
import styles from './style.module.less'

/** 开店助手 */
@auth(SHOP_ASSISTANT)
export default class UpgradeTips extends Component {
  state = {
    data: []
  }

  async componentDidMount() {
    const { success, data } = await Api.shopAssistantApi()
    if (success) {
      this.setState({ data: this.formatData(data) }, () => {})
    }
  }

  /** 加上路由及icon信息 */
  formatData = data => {
    return data.map((item, index) => {
      const exStatus = index === 0 ? 1 : data[index - 1].status
      return {
        ...item,
        ...getPath()[item.step],
        stepStatus: item.status,
        exStatus
      }
    })
  }

  getIcon = ({ exStatus, stepStatus, index, title }) => {
    let dom
    index = index + 1
    if (stepStatus == 0) {
      if (index == 1) {
        dom = <div className={styles.arriving}>{index}</div>
      } else if (index == this.state.data.length) {
        dom = (
          <div className={styles.success}>
            <img
              width={24}
              src={
                isSiDaProperty()
                  ? '//qnm.hunliji.com/FpE_DXmxufAaDc6eicNTBN0A-6Al'
                  : '//qnm.hunliji.com/FqOnbMrEO7TlNd5wP2JBIIn_uZKE'
              }
              alt="开店成功"
            />
          </div>
        )
      } else if (exStatus == 1 && stepStatus == 0) {
        dom = <div className={styles.arriving}>{index}</div>
      } else {
        dom = <div className={styles.wait}>{index}</div>
      }
    } else if (stepStatus == 1) {
      dom = (
        <div className={styles.finished}>
          <img
            width={24}
            src={
              isSiDaProperty()
                ? '//qnm.hunliji.com/FseY4aHs46akOqNfSBhJTf3yowdV'
                : '//qnm.hunliji.com/FhBdBySsuWAWe6BE7Cz1-l6Nqprt'
            }
            alt="完成"
          />
        </div>
      )
    }

    return (
      <Tooltip
        placement="top"
        arrowPointAtCenter
        overlayStyle={{ zIndex: 9, width: 'max-content' }}
        getPopupContainer={container => container?.parentNode || document.body}
        visible={stepStatus == 0 && exStatus == 1}
        title={<span>{title}</span>}
      >
        {dom}
      </Tooltip>
    )
  }

  step = ({ exStatus, stepStatus, name, step }, index) => {
    const title = `第${index + 1}步：` + name
    return (
      <Steps.Step
        key={step}
        title={!(stepStatus == 0 && exStatus == 1) && title}
        icon={this.getIcon({ exStatus, stepStatus, index, title })}
      />
    )
  }

  /** 查看攻略 */
  toMethod = () => {
    const id = isHotelMerchant() ? 535 : 534
    window.location.href = `#/localMerchant/businessSchool/${id}`
  }

  /** 去完成 */
  goFinish = current => {
    const { path, extra } = current
    window.location.href = path
    extra && extra()
  }

  render() {
    const { data } = this.state
    if (!Object.keys(data).length) {
      return null
    }
    const current = data.find(item => item.stepStatus == 0)

    const isSiDa = isSiDaProperty() // 四大商家样式不同

    return current ? (
      <div
        className={cls(styles.upgrade_tips_wrap, {
          [styles.upgrade_tips_wrap_notSiDa]: !isSiDa
        })}
      >
        {/* 状态提示语 && 操作按钮 */}
        <div className={styles['notice_and_operation']}>
          <div>
            {isSiDa ? (
              <>
                <p className={styles.title}>
                  当前{isTeam() ? '团队' : ''}店铺状态异常
                </p>
                <p className={styles.desc}>
                  无法在用户APP端显示，请尽快完成以下操作
                </p>
              </>
            ) : (
              <div className={styles.openShopTop}>
                <span className={styles.openShopTitle}>开店助手</span>
                <Tooltip
                  placement="top"
                  title={
                    <span>开店助手，丰富店铺内容，新商家获客的必经之路</span>
                  }
                >
                  <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                </Tooltip>
                <a onClick={this.toMethod} className={styles.methodBtn}>
                  查看攻略
                </a>
              </div>
            )}
          </div>
          {current && (
            <Button
              className={styles.operation}
              // onClick={() => {
              //   window.location.href = current.path
              // }}
              onClick={() => {
                this.goFinish(current)
              }}
            >
              立即{current.name.substring(0, 2)}
              <img
                src="https://qnm.hunliji.com/FvRPTjXsV9VzZJXFyybde7jbyV7Y"
                width={8}
                height={15}
              />
            </Button>
          )}
        </div>
        {/* step */}
        <div className={styles['step_wrap']}>
          <Steps labelPlacement="vertical" className={styles.step}>
            {data.map((item, index) => this.step(item, index))}
          </Steps>
        </div>
      </div>
    ) : (
      <div className={styles.open_shop_success} />
    )
  }
}
